var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentsSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8029 2.99634C13.225 2.99634 13.6017 3.26137 13.7443 3.65861L14.2525 5.0742C14.3332 5.29681 14.4898 5.48385 14.6947 5.60242L16.2024 6.47279C16.4071 6.59091 16.647 6.63273 16.8796 6.59083L18.3603 6.32372C18.776 6.24812 19.1945 6.44192 19.4057 6.80793L20.206 8.1885C20.4178 8.55351 20.3778 9.01217 20.106 9.33498L19.1346 10.4835C18.9816 10.664 18.8976 10.893 18.8975 11.1297V12.8705C18.8976 13.1071 18.9816 13.3361 19.1346 13.5167L20.106 14.6652C20.3778 14.988 20.4178 15.4467 20.206 15.8117L19.4057 17.1923C19.1946 17.5579 18.7767 17.7516 18.3613 17.6765L16.8806 17.4093C16.648 17.3674 16.4081 17.4093 16.2034 17.5274L14.6957 18.3978C14.4908 18.5163 14.3342 18.7034 14.2535 18.926L13.7453 20.3416C13.6025 20.7392 13.2254 21.0042 12.8029 21.0038H11.2023C10.7802 21.0038 10.4036 20.7388 10.2609 20.3416L9.75267 18.926C9.67203 18.7037 9.51589 18.5167 9.31149 18.3978L7.80286 17.5274C7.59814 17.4093 7.3582 17.3674 7.12558 17.4093L5.64496 17.6765C5.2292 17.7521 4.81077 17.5583 4.59953 17.1923L3.7992 15.8117C3.58739 15.4467 3.62742 14.988 3.89924 14.6652L4.87064 13.5167C5.02364 13.3361 5.10765 13.1071 5.10774 12.8705V11.1297C5.10765 10.893 5.02364 10.664 4.87064 10.4835L3.90924 9.33498C3.63742 9.01217 3.5974 8.55351 3.8092 8.1885L4.60953 6.80793C4.82064 6.44232 5.23853 6.24858 5.65397 6.32372L7.13458 6.59083C7.3672 6.63273 7.60714 6.59091 7.81187 6.47279L9.32049 5.60242C9.52489 5.48347 9.68103 5.29652 9.76168 5.0742L10.2699 3.65861C10.4114 3.26446 10.7835 3.00017 11.2023 2.99634H12.8029Z",
    stroke: "#1D2023",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.0011,
    cy: 12.0002,
    r: 2.75115,
    stroke: "#1D2023",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsSettingsIcon);
export default __webpack_public_path__ + "static/media/payments-settings-icon.3a48160b4ee87a6a4fe3a5cb5b8a9803.svg";
export { ForwardRef as ReactComponent };